import _ from 'lodash';
export const setChildObj = () => {};

export const linkMainMenu = (param: { num: any; navigate?: any }) => {
  if (param.navigate) {
    param.navigate('/main', {
      state: { pageNum: param.num || 0 },
    });
  }
};
export const linkMenu = (param: { selItem?: any; menuData: any; setMenu: any; navigate?: any }) => {
  initActiveMenu(param.menuData);
  if (param.selItem) setActiveMenu(param.selItem, param.menuData);
  const chekedMenu = checkMenu(param.menuData, param.selItem);

  if (param.navigate) {
    param.navigate('/main', {
      state: { template: chekedMenu.template || '', id: chekedMenu.selectMenu?.id || 0 },
    });
  }
};

export const linkTemplate = (param: {
  template?: any;
  menuId: any;
  setMenu: any;
  navigate?: any;
}) => {
  if (param.navigate) {
    param.navigate('/main', {
      state: { id: param.menuId || 0 },
    });
  }
};

export const linkDirectMenu = (param: {
  selItem?: any;
  menuData: any;
  setMenu: any;
  redirect: any;
}) => {
  return param.redirect('/login');
};

export const linkUrl = (param: { url: any; navigate: any; state?: any }) => {
  const stateSet = param.state || {};
  param.navigate(param.url, {
    state: stateSet,
  });
};

export const logout = (param: { url?: any; navigate: any }) => {
  param.navigate(param.url, {
    state: {},
  });
};

// 선택된 값을 활성화함
const setActiveMenu = (selItem: any, menuData: any) => {
  let loofFlag = true;
  const setMenuObject = (selItem: any, allData: any) => {
    let retFlag = false;
    allData.forEach((item: any) => {
      if (selItem.id === item.id) {
        loofFlag = false;
        item.active = true;
        retFlag = true;
      }
      if (item.child.length > 0 && loofFlag) {
        const flag = setMenuObject(selItem, item.child);
        if (flag) {
          retFlag = true;
          item.active = true;
        }
      }
    });
    return retFlag;
  };
  setMenuObject(selItem, menuData);
};

// 모든메뉴 상태값을 비활성화 함
export const initActiveMenu = (menuData: any) => {
  const init = (menu: any) => {
    menu.active = false;
    if (menu.child.length > 0) {
      for (const item of menu.child) {
        init(item);
      }
    }
  };
  for (const item of menuData) {
    init(item);
  }
};

const checkMenu = (menuData: any, selItem: any) => {
  const menuPayload = {
    template: '',
    selectMenu: selItem,
    depth1: {},
    depth2: {},
    depth3: {},
    depth4: {},
  };
  const recCheckData = (data: any, menuPayload: any) => {
    data.forEach((item: any) => {
      if (item.active) {
        if (item.level === 1) menuPayload.depth1 = item;
        if (item.level === 2) menuPayload.depth2 = item;
        if (item.level === 3) menuPayload.depth3 = item;
        if (item.level === 4) menuPayload.depth4 = item;
        if (item.child.length > 0) recCheckData(item.child, menuPayload);
      }
    });
  };
  const menuTemplate = selItem?.template || '';
  menuPayload.template = menuTemplate;
  if (!menuTemplate) {
    menuPayload.template = 'home';
    setMenuTemplate(selItem, menuPayload);
  }
  recCheckData(menuData, menuPayload);

  return menuPayload;
};

const setMenuTemplate = (selItem: any, menuPayload: any) => {
  const level = selItem?.level;
  if (!level) return false;

  const recCheckData = (data: any, menuPayload: any) => {
    const template = data[0]?.template || '';
    const level = data[0]?.level || '';
    const child = data[0]?.child || [];

    menuPayload[`depth${level}`] = data[0];
    if (template !== '') {
      menuPayload.template = template;
      menuPayload.selectMenu = data[0];
    }
    if (child.length > 0) recCheckData(data[0].child, menuPayload);
  };

  recCheckData(selItem.child, menuPayload);
};

// id값과 일치하는 메뉴 반환
export const selectMenuObj = (id: string, menuData: any) => {
  let retObj = null;

  const recCheckData = (id: any, menus: any) => {
    menus.forEach((item: any) => {
      if (item.id === id) {
        retObj = item;
      } else {
        if (item.child.length > 0) {
          recCheckData(id, item.child);
        }
      }
    });
  };
  recCheckData(id, menuData);
  return retObj;
};

// id값과 일치하는 메뉴 반환
export const setMenuObj = (id: string, menuData: any) => {
  // let retObj = null;
  let chekedMenu = null;
  const selectMenu = selectMenuObj(id, menuData);
  if (selectMenu) {
    initActiveMenu(menuData);
    setActiveMenu(selectMenu, menuData);
    chekedMenu = checkMenu(menuData, selectMenu);
  }
  return { menuData, chekedMenu };
};

// 트리내 모든값 세팅
export const setMenuObjValue = (menuData: any, field: string, value: any) => {
  const setChild = (menus: any) => {
    for (const item of menus) {
      item[field] = value;
      if (item.child.length > 0) setChild(item.child);
    }
  };
  for (const item of menuData) {
    item[field] = value;
    if (item.child.length > 0) setChild(item.child);
  }
};

// 부모ID 세팅
export const getParentId = (menuData: any, upId: string) => {
  const menuArray = menuChildToArrray(menuData);
  const retArray: any = [];

  const setParent = (menus: any, menuUpId: any) => {
    for (const item of menus) {
      if (item.menu_idx === menuUpId) {
        retArray.push(item.menu_idx);
        setParent(menuArray, item.up_menu_idx);
      }
    }
  };
  setParent(menuArray, upId);
  const retStr = retArray.reverse().join('.');
  return retStr;
};

// 트리내 선택된 값 변경(하위 미포함)
export const setThisMenuObjValue = (menuData: any, selectId: number, field: string, value: any) => {
  const setChild = (menu: any) => {
    if (menu.menu_idx === selectId) {
      menu[field] = value;
    }
    if (menu.child.length > 0) {
      menu.child.forEach((item: any) => {
        setChild(item);
      });
    }
  };
  for (const item of menuData) {
    setChild(item);
  }
};

// 트리내 선택된 값 변경(하위포함)
export const setChildMenuObjValue = (
  menuData: any,
  selectId: number,
  field: string,
  value: any
) => {
  const setChild = (menu: any, chkFlag: boolean) => {
    if (chkFlag || menu.menu_idx === selectId) {
      menu[field] = value;
      chkFlag = true;
    }
    if (menu.child.length > 0) {
      menu.child.forEach((item: any) => {
        setChild(item, chkFlag);
      });
    }
  };
  for (const item of menuData) {
    setChild(item, false);
  }
};

// 메뉴 드래그 시 트리체크
export const setDragChildMenuObjValue = (
  menuData: any,
  dragId: number,
  dropId: number,
  hoverType: string
) => {
  setMenuObjValue(menuData, 'itemType', { status: '', hover: '' });

  const setChild = (menu: any, chkFlag: boolean) => {
    if (chkFlag || menu.menu_idx === dragId) {
      menu.itemType = { status: 'drag', hover: '' };
      chkFlag = true;
    }
    if (!chkFlag && menu.menu_idx === dropId) {
      menu.itemType = { status: 'drag_drop', hover: hoverType };
    }
    if (menu.child.length > 0) {
      menu.child.forEach((item: any) => {
        setChild(item, chkFlag);
      });
    }
  };
  for (const item of menuData) {
    setChild(item, false);
  }
};

// 계층구조를 배열로 변환
export const menuChildToArrray = (menuData: any) => {
  const retMenu = [];
  const setChild = (menus: any) => {
    for (const item of menus) {
      retMenu.push(item);
      if (item.child.length > 0) setChild(item.child);
    }
  };
  for (const item of menuData) {
    retMenu.push(item);
    if (item.child.length > 0) setChild(item.child);
  }
  return retMenu;
};

// 계층구조를 배열로 변환
export const resetMenuChildToArrray = (menuData: any) => {
  const retMenu: any = [];
  let displayNum = 0;

  const deleteAttr = (item: any) => {
    delete item.active;
    delete item.disable;
    delete item.fold;
    delete item.child;
    delete item.itemType;
  };

  const setChild = (menus: any, menuIdxArr: any, upMenuId: any) => {
    for (const item of menus) {
      item.menu_hierarchy = menuIdxArr.join('.') + '.' + item.menu_idx;
      displayNum++;
      item.menu_display_order = displayNum;
      item.up_menu_idx = upMenuId;
      const reItem = _.cloneDeep(item);
      deleteAttr(reItem);

      retMenu.push(reItem);
      const menuReArr = _.cloneDeep(menuIdxArr);
      menuReArr.push(item.menu_idx);
      if (item.child.length > 0) setChild(item.child, menuReArr, item.menu_idx);
    }
  };
  for (const item of menuData) {
    displayNum++;
    item.menu_display_order = displayNum;
    const menuIdxArr = [item.menu_idx];
    const reItem = _.cloneDeep(item);
    deleteAttr(reItem);

    retMenu.push(reItem);
    if (item.child.length > 0) setChild(item.child, menuIdxArr, item.menu_idx);
  }
  return retMenu;
};

// 계층구조에서 선택된 값 제거
export const removeSelectValue = (menuData: any, selectId: any) => {
  const setChild = (menuArr: any) => {
    const reArr = menuArr.filter((item: any) => item.menu_idx !== selectId);
    for (const item of reArr) {
      if (item.child.length > 0) {
        const reData = setChild(item.child);
        item.child = reData;
      }
    }
    return reArr;
  };

  let retMenuData: any = [];
  retMenuData = setChild(menuData);
  return retMenuData;
};

// 선택구조 아래 레벨값을 1씩 올린다.
const addLevelMenu = (menu: any, menuLevel: any) => {
  let maxLevel = 0;
  const setChild = (menuArr: any, mLevel: any) => {
    for (const item of menuArr) {
      item.menu_level = mLevel;
      if (mLevel > maxLevel) maxLevel = mLevel;
      if (item.child.length > 0) {
        setChild(item.child, mLevel + 1);
      }
    }
  };

  setChild(menu.child, menuLevel);
  return maxLevel;
};

// 자식 노드내 TargetID가 있는지 체크
const checkChildTarget = (menuData: any, targetId: number) => {
  let retFlag = false;
  const setChild = (menuArr: any, target: number) => {
    for (const item of menuArr) {
      if (item.menu_idx === targetId) retFlag = true;
      if (!retFlag && item.child.length > 0) {
        setChild(item.child, targetId);
      }
    }
  };
  if (menuData.menu_idx === targetId) {
    retFlag = true;
    return retFlag;
  }
  setChild(menuData.child, targetId);
  return retFlag;
};

// 계층구조에서 타겟값 아래 선택값 배치
export const placeSelectValue = (
  menuData: any,
  selectObj: any,
  targetId: any,
  hoverType: string
) => {
  const setChild = (menuArr: any, putData: any) => {
    for (const item of menuArr) {
      putData.push(item);
      if (item.menu_idx === targetId) {
        if (hoverType === 'up') {
          selectObj.menu_level = item.menu_level;
          selectObj.up_menu_idx = item.up_menu_idx;
          const menuLevel = item.menu_level + 1;
          selectObj.append_type = 'sibling';
          const mLevel = addLevelMenu(selectObj, menuLevel);
          maxLevel = mLevel;
          putData.pop();
          putData.push(selectObj);
          putData.push(item);
        } else if (hoverType === 'down') {
          selectObj.menu_level = item.menu_level;
          selectObj.up_menu_idx = item.up_menu_idx;
          const menuLevel = item.menu_level + 1;
          selectObj.append_type = 'sibling';
          const mLevel = addLevelMenu(selectObj, menuLevel);
          maxLevel = mLevel;
          putData.push(selectObj);
        } else {
          selectObj.menu_level = item.menu_level + 1;
          selectObj.up_menu_idx = item.menu_idx;
          selectObj.append_type = 'child';

          // set MenuHirearchy
          const menuHirearchy = item.menu_hierarchy;
          const menuHirearchyArr = menuHirearchy.split('.') || [];
          menuHirearchyArr.length > 0 && menuHirearchyArr.pop();
          menuHirearchyArr.push(selectObj.up_menu_idx);
          menuHirearchyArr.push(selectObj.menu_idx);
          const menuHirearchyStr = menuHirearchyArr.join('.');
          selectObj.menu_hierarchy = menuHirearchyStr;

          const menuLevel = item.menu_level + 2;
          const mLevel = addLevelMenu(selectObj, menuLevel);
          maxLevel = mLevel;
          item.child.push(selectObj);
        }
      }
      if (item.child.length > 0) {
        const cloneChild = _.cloneDeep(item.child);
        item.child = [];
        setChild(cloneChild, item.child);
      }
    }
  };

  const retMenuData: any = [];
  let maxLevel = 0;
  setChild(menuData, retMenuData);

  return { resetData: retMenuData, maxLevel };
};

// 순번 변경
export const dragEndMenuData = (
  menuData: any,
  selectItem: any,
  targetId: any,
  hoverType: string
) => {
  const cloneData = _.cloneDeep(menuData);
  const cloneSelectItem = _.cloneDeep(selectItem);
  // 1. 전체 데이터에서 선택값제거
  const initData = removeSelectValue(cloneData, cloneSelectItem.menu_idx);
  // 2. 타겟 값 아래에 선택값 배치
  const { resetData, maxLevel } = placeSelectValue(initData, cloneSelectItem, targetId, hoverType);
  const validation = { flag: '', message: '' };
  const childIdFlag = checkChildTarget(selectItem, targetId);
  if (childIdFlag) {
    validation.flag = 'error';
    validation.message = '하위레벨로 이동할 수 없습니다.';
  }
  if (maxLevel > 4) {
    validation.flag = 'error';
    validation.message = '최대 4레벨까지 이동 가능합니다.';
  }

  return { data: resetData, validation };
};

export const menuPayload = {
  active: true,
  disable: false,
  itemType: { status: '', hover: '' },
  child: [],
  create_date: '',
  create_user_id: '',
  fold: true,
  is_category_use: false,
  is_menu_use: true,
  is_observgroup_use: false,
  is_reply_image: false,
  is_user_write: false,
  menu_detail: '',
  menu_display_order: 0,
  menu_hierarchy: '',
  menu_idx: 0,
  menu_level: 1,
  menu_name: '',
  menu_template: '',
  menu_type: 'folder',
  up_menu_idx: 0,
  update_date: '',
  update_user_id: '',
  append_type: '',
};

// EVT:Fold
export const foldMenu = (e: React.MouseEvent, item: any, menuData: any, setState: any) => {
  const childFold = item.child[0]?.fold || false;
  const childFoldFlag = childFold ? false : true;

  const setChildFold = (childs: any, flag: boolean) => {
    for (const cItem of childs) {
      cItem.fold = flag;
      if (cItem.child.length > 0) setChildFold(cItem.child, flag);
    }
  };
  if (item.child.length > 0) {
    setChildFold(item.child, childFoldFlag);
  }
  setState({ data: menuData });
};

// 하위레벨 추가
export const addChildMenu = (
  e: React.MouseEvent,
  item: any,
  menuData: any,
  menuIdx: number,
  setState: any
) => {
  const payload = _.cloneDeep(menuPayload);
  payload.menu_level = item.menu_level + 1;
  payload.up_menu_idx = item.menu_idx;
  payload.menu_idx = menuIdx;
  payload.menu_hierarchy = getParentId(menuData, item.menu_idx);

  payload.append_type = 'child';
  setMenuObjValue(menuData, 'disable', true);
  item.child.push(payload);
  setState({ data: menuData, viewType: 'insert', selectItem: payload });
};

// 동일레벨 추가
export const addSameMenu = (
  e: React.MouseEvent,
  item: any,
  menuData: any,
  menuIdx: number,
  setState: any
) => {
  const payload = _.cloneDeep(menuPayload);
  payload.menu_level = item.menu_level;
  payload.up_menu_idx = item.up_menu_idx;
  payload.menu_hierarchy = getParentId(menuData, item.menu_idx);
  payload.append_type = 'sibling';
  payload.menu_idx = menuIdx++;
  setMenuObjValue(menuData, 'disable', true);

  const setChildCheck = (menuItem: any) => {
    const resetChildMenuData = [];
    if (menuItem.menu_idx === item.menu_idx) {
      return true;
    } else {
      if (menuItem.child.length > 0) {
        for (const menu of menuItem.child) {
          const retFlag = setChildCheck(menu);
          resetChildMenuData.push(menu);
          if (retFlag) resetChildMenuData.push(payload);
        }
      }
      menuItem.child = resetChildMenuData;
    }
  };

  const resetMenuData = [];
  for (const menuItem of menuData) {
    const retFlag = setChildCheck(menuItem);
    resetMenuData.push(menuItem);
    if (retFlag) resetMenuData.push(payload);
  }
  setState({ data: resetMenuData, viewType: 'insert', selectItem: payload });
};

// 메뉴 수정
export const modifyMenu = (e: React.MouseEvent, item: any, menuData: any, setState: any) => {
  setMenuObjValue(menuData, 'disable', true);
  setThisMenuObjValue(menuData, item.menu_idx, 'disable', false);
  item.active = '_active';
  setState({ data: menuData, viewType: 'update', selectItem: item });
};
